// extracted by mini-css-extract-plugin
module.exports = {"linkIcon":"linkIcon--b548d","venueField":"venueField--0904f"};